import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/CARRIERS`;

export const REDUCER_NAME = 'carriers';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/accounts?type=COURIER,PRIMARY_COURIER`;

export const ROUTES = {
  ROOT: '/transporters',
};

export const TABLE_NAME = I18n.str('transporters', 'Transporters');
export const ACTION_NAME = I18n.str('createTransporter', 'Create Transporter');
export const ITEM_KEY = 'transporters';

export const AGENT_KEYS = [
  { value: 'FREIGHT_FORWARDER', label: I18n.str('FREIGHT_FORWARDER', 'FREIGHT FORWARDER') },
  {
    value: 'CARRIER',
    label: I18n.str('CARRIER', 'CARRIER'),
  },
];
